export const isEmpty = (
  v: unknown,
): v is null | undefined | 0 | false | '' | Record<PropertyKey, never> | [] => {
  if (typeof v === 'function') return false

  if (!v) return true // null, undefined, 0, false, ""

  if (Array.isArray(v)) return !v.length

  if (typeof v === 'object') return !Object.keys(v).length

  return false
}
